<template>
  <div :class="$vuetify.breakpoint.xs ? 'background' : ''">
    <v-main>
      <v-container>
        <div v-if="$vuetify.breakpoint.xs">
          <v-card
            style="
              padding: 44px 26px 55px 26px;
              margin-bottom: 150px;
              box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
              border-radius: 16px;
              margin-top: 48px;
            "
          >
            <v-col style="text-align: center" class="px-0" v-if="checkTrue">
              <img
                style="margin-top: 18px"
                width="200px"
                height="200px"
                src="@/assets/img/mobileAuthIcons/successIcon.svg"
              />
              <p
                style="
                  font-family: 'Gilroy-Bold';
                  font-size: 32px;
                  line-height: 38px;
                  color: #5e5e5e;
                "
              >
                <strong>{{ "success_activation_title" | localize }} </strong>
              </p>
              <p style="text-align: center">
                {{ "success_activation" | localize }}
              </p>
            </v-col>
            <v-col style="text-align: center" class="px-0" v-if="checkFalse">
              <img
                style="margin-top: 18px; object-fit: cover"
                width="178px"
                height="179px"
                src="@/assets/img/mobileAuthIcons/fail.png"
              />
              <p style="text-align: center; margin-top: 15px">
                {{ "wrong_activation_code" | localize }}
              </p>
            </v-col>
            <v-card-actions v-if="checkTrue">
              <router-link style="width: 100%" to="/login"
                ><v-btn block outlined color="#72AFE7">{{
                  "sign_in" | localize
                }}</v-btn></router-link
              >
            </v-card-actions>
          </v-card>
        </div>
        <div
          v-else
          class="justify-center align-center mx-auto col-12 col-sm-7 col-md-4 my-15"
        >
          <v-card class="px-5">
            <v-card-title class="mb-3">{{
              "success_activation_title" | localize
            }}</v-card-title>
            <v-card-text v-if="checkTrue">
              {{ "success_activation" | localize }}
            </v-card-text>
            <v-card-text v-if="checkFalse">
              {{ "wrong_activation_code" | localize }}
            </v-card-text>
            <v-card-actions v-if="checkTrue">
              <router-link style="width: 100%" to="/login"
                ><v-btn block outlined color="#72AFE7">{{
                  "sign_in" | localize
                }}</v-btn></router-link
              >
            </v-card-actions>
          </v-card>
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import AuthService from "@/requests/Auth/AuthService";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    checkTrue: false,
    checkFalse: false,
  }),
  mounted() {
    this.checkActivationCode();
  },
  methods: {
    async checkActivationCode() {
      try {
        var form = new FormData();
        form.append("activation_code", this.$route.params.code);
        form.append("lang", this.user.locale);
        form.append("type", process.env.VUE_APP_TYPE);
        var response = await AuthService.activate(form);
        if (response.status == 200) {
          this.checkTrue = true;
          setTimeout(() => {
            this.$router.push("/login");
          }, 10000);
        }
      } catch (e) {
        // this.checkFalse = true;
      }
    },
  },
  watch: {
    user: function (newUser) {
      this.user = newUser;
      this.getCountries();
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style scoped>
a {
  color: #72afe7;
  text-decoration: none;
}
.background {
  background-image: url("../assets/img/mobileAuthIcons/mobileBackground.svg");
  height: 800px;
  width: 100%;
  background-size: auto;
  background-repeat: repeat;
}
</style>